export type ListOptions = Record<string, string>;
export type ListOptionNum = { value: number; text: string };
export type ListOption<T> = { value: T; text: string };
export type ListOptionEx<T0, T1> = { value: T0; text: string; tag: T1 };
export type ListOptionSel<T> = { value: T; text: string; selectable: boolean };

export const noneOptNum: ListOptionNum = {
  value: 0,
  text: 'なし',
};
